"use strict";

exports.__esModule = true;
exports.TabPanel = exports.TabList = exports.Tab = exports.StyledTabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _styledSystem = require("styled-system");

var _reactTabs = require("react-tabs");

var _breakpoints = require("../../../helpers/breakpoints");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getTabGutter = theme => {
  const [size, units] = (0, _polished.getValueAndUnit)(theme.gridGutterWidth);
  return `${size / 2}${units}`;
}; // prevent the animated prop from rendering in the DOM


const StyledTabs = (0, _styledComponents.default)(({
  animated,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTabs.Tabs, { ...props
}))`
    width: 100%;

    ${({
  animated
}) => animated && (0, _styledComponents.css)`
        & > ul > li {
            transition: all 250ms;
        }
    `};
`;
exports.StyledTabs = StyledTabs;
const StyledTabList = (0, _styledComponents.default)(({
  tabWidth,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTabs.TabList, { ...props
}))`
    list-style-type: none;
    padding-left: ${({
  theme
}) => getTabGutter(theme)};
    display: flex;
    margin: 0;

    ${({
  tabWidth
}) => tabWidth && (0, _styledComponents.css)`
        & > li {
            flex: ${tabWidth === 'auto' ? 'auto 0' : '1'};
        }
    `};
`;
exports.TabList = StyledTabList;
StyledTabList.tabsRole = 'TabList';
const StyledTab = (0, _styledComponents.default)(_reactTabs.Tab)`
    flex: 1;
    margin-right: ${({
  theme
}) => getTabGutter(theme)};
    margin-top: ${({
  theme
}) => theme.space[4]};
    padding:  ${({
  theme
}) => theme.space[5]} ${({
  theme
}) => theme.space[3]};
    font-size: ${({
  theme
}) => theme.fontSizes[3]};
    font-weight: ${({
  theme
}) => theme.fontWeights.bold};
    text-align: center;
    color: ${({
  theme
}) => theme.colors.tabs.text};
    border: 1px solid ${({
  theme
}) => theme.colors.tabs.background};
    user-select: none;
    cursor: pointer;

    ${_breakpoints.breakpointUp.md`
        font-size: ${({
  theme
}) => theme.fontSizes[4]};
        padding: ${({
  theme
}) => theme.space[5]};
    `}

    &.tab--selected {
        background-color: ${({
  theme
}) => theme.colors.tabs.background};
        padding-top: ${({
  theme
}) => `calc(${theme.space[5]} + ${theme.space[4]})`};
        margin-top: 0;
    }

    &:focus {
        outline: none;
    }

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.Tab = StyledTab;
StyledTab.tabsRole = 'Tab';
const StyledTabPanel = (0, _styledComponents.default)(_reactTabs.TabPanel)`
    display: none;
    padding: ${({
  theme
}) => theme.space[5]};
    margin-top: -5px;
    background-color: ${({
  theme
}) => theme.colors.tabs.background};

    &.tab-panel--selected {
        display: block;
    }

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
`;
exports.TabPanel = StyledTabPanel;
StyledTabPanel.tabsRole = 'TabPanel';